import { ROLES } from '@/constants/roles';

export default [
  {
    path: '/find-shipment',
    name: 'find_shipment',
    component: () => import('@/views/pages/find-shipment/BulkFindShipment.vue'),
    meta: {
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.OPERATION_MANAGER],
      verticalMenu: {
        title: 'Find Shipment',
        icon: 'SearchIcon'
      }
    }
  },
  {
    path: '/find-shipment/detail',
    name: 'find_shipment_detail',
    component: () => import('@/views/pages/find-shipment/FindShipment.vue'),
    meta: {
      navActiveLink: 'find_shipment',
      roles: [ROLES.ADMIN, ROLES.ACCOUNT_ADMIN, ROLES.OPERATION_MANAGER]
    }
  }
];
